import React from "react";

interface CartItem {
  id: number;
  image: string;
  name: string;
  price: number;
  quantity: number;
  item_quantity: number;
  color?: string;
  original_price: number;
  images_black?: string[];
  images_white?: string[];
}

interface CartTableProps {
  cart: CartItem[];
}

const CheckoutCartItems: React.FC<CartTableProps> = ({ cart }) => {
  const getProductImage = (item: CartItem) => {
    return item.image;
  };

  const capitalizeFirstLetter = (str: string | null | undefined) => {
    if (!str) return "";
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div className="bg-white rounded-xl p-5">
      <h2 className="text-xl font-bold text-[#005D6E] mb-4">Cart Items</h2>
      <div className="space-y-4">
        {cart.map((item) => (
          <div 
            key={item.id} 
            className="flex items-center border-b border-gray-100 pb-4 last:border-b-0"
          >
            {/* Product Image */}
            <div className="flex-shrink-0 mr-4">
              <img
                className="w-20 h-20 object-contain bg-gray-50 rounded-lg"
                src={getProductImage(item)}
                alt={capitalizeFirstLetter(item.name)}
              />
            </div>
          
            <div className="flex-grow">
              <div className="flex justify-between items-start">
                <div className="w-3/4">
                  <h4 className="text-base font-medium text-gray-800 leading-tight">
                    {capitalizeFirstLetter(item.name)}
                  </h4>
                  <p className="text-gray-500 text-sm mt-1">
                    Quantity: {item.item_quantity}
                  </p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-[#005D6E]">
                    R {item.price * item.item_quantity}
                  </p>
                  <p className="text-gray-500 text-sm mt-1">
                    R {item.price} each
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CheckoutCartItems;